import { BaseWebComponent } from "../base-components/base-web-component";
import { isNumber } from "@bonusmap/shared_ui/library";
interface DataToolbarReference  {
    id: string;
    index: number;
    title: string;
    element: HTMLElement;
    active?: boolean;
}
export class DataToolbar extends BaseWebComponent {
    static webComponentName: string = "data-toolbar";
    protected _templateId: string = "data-toolbar"; // Template ID for rendering
    constructor() {
        super();
        this.setupGlobalListeners();
        this.style.display = "block"; // Ensure the toolbar is displayed as a block element
        // rimuove l'elemento se collectorEl è '.action-view'
        if(
            this.collectorEl?.classList.contains('action-view') ||
            this.dataGroupsElements.length <= 1) {
            this.remove();
            return;
        }
        
    }
    private references: DataToolbarReference[] = [];
    private _collectorEl: HTMLElement | null = null;
    public get collectorEl(): HTMLElement | null {
        if(!this._collectorEl) {
            this._collectorEl = this.closest('data-base-collector');
        }
        return this._collectorEl;
    }
    private _dataGroupsElements: HTMLElement[] = [];
    public get dataGroupsElements(): HTMLElement[] {
        if(this._dataGroupsElements.length === 0 && this.collectorEl) {
            this._dataGroupsElements = Array.from(this.collectorEl.querySelectorAll('data-group[data-title]'));
            const hasActive = this._dataGroupsElements.some(el => el.classList.contains('active'));
            // si assicura che ogni elemento abbia un id
            this._dataGroupsElements.forEach((el, index) => {
                if(!el.id) {
                    el.id = `data-group-${index+1}`;
                }
                if(!hasActive && index === 0) {
                    el.classList.add('active');
                }
                this.references.push({
                    id: el.id, 
                    index, 
                    title: el.getAttribute('data-title') || `Group ${index+1}`, 
                    element: el,
                    active: el.classList.contains('active')
                });
            });
        }
        return this._dataGroupsElements;
    }
    private setActiveGroup(index: number): void {
        this.references.forEach(ref => {
            if(ref.index === index) {
                ref.element.classList.add('active');
                ref.active = true;
            } else {
                ref.element.classList.remove('active');
                ref.active = false;
            }
        });
        this.render(); // Rerender to update the active state in the toolbar
    }
    private setupGlobalListeners(): void {
        this.on("click", "button[data-index]", (ev: Event) => {
            ev.preventDefault();
            const btn = ev.target as HTMLElement;
            const indexAttr = btn.getAttribute('data-index');
            if(!indexAttr) return;
            const index = parseInt(indexAttr);
            if(!isNumber(index) || index < 0 || index >= this.dataGroupsElements.length) return;
            this.setActiveGroup(index);
        // eventi globali delegati
        });
    }
    protected buildRenderingData(): Record<string, any> {
        return {
            items: this.references,
            // Add any additional data needed for the template here
        };
    }
}